/** Full NFG Games suite from the live TikTok overlay. */
export const GAMES = [
  {
    id: "nfg_crash",
    slug: "nfg-crash",
    name: "NFG Crash",
    tag: "NUMBER SIM · LIVE",
    tagline: "Read the curve, cash out before the crash — chat-driven number sim with live MVP races.",
    description:
      "Join live rounds, read the multiplier curve, and cash out before the crash. Shared virtual points, synchronized mobile play, and session MVP competition on @y666.suf.",
    image: "/games/nfg-crash.png",
    accent: "#B56CFF",
    stats: { live: true },
    featured: true,
    switchCommand: "crash",
    howToPlay: {
      overview:
        "A rising multiplier curve runs each round. Bet virtual Crash points, then cash out before it crashes. Last cashout before the crash is safe — wait too long and your bet is lost.",
      goal: "Cash out with the highest safe multiplier you can risk.",
      chat: [
        "Use Crash chat commands on the live (and companion where enabled): bet size, cashout, and balance checks.",
        "!tutorial / !howto — full on-stream how-to (stays up 20s+, 10 min cooldown).",
        "!balance / !bal / !points — show your Crash wallet (always allowed).",
        "Bets and cashouts are typed in chat or tapped in the companion — virtual points only, no real-money cash-out.",
      ],
      gifts: [
        "Gifts still feed session throne / spend-war and live FX.",
        "Money Gun lets the gifter type crash (or another game name) within 45s to switch modes.",
      ],
      tips: [
        "Early cashouts are safer; late cashouts pay more but risk a crash.",
        "Watch the MVP / peak win cards for the session’s best runs.",
      ],
    },
  },
  {
    id: "nfg_fuse",
    slug: "nfg-fuse",
    name: "NFG Fuse",
    tag: "WORD CHAIN · NEW",
    tagline: "Last letter + exact length · UK dictionary · keep the fuse alive.",
    description:
      "Chat types valid UK words that start with the last letter of the current word and match the required length. Hits extend the fuse; when it blows, the chain resets.",
    image: "/games/nfg-fuse.png",
    accent: "#E8C547",
    switchCommand: "fuse",
    howToPlay: {
      overview:
        "A seed word starts the chain. The overlay shows the required starting letter and exact length for the next word. A fuse burns down — valid hits extend it.",
      goal: "Keep the chain alive with legal UK words and rack up link points before the fuse blows.",
      chat: [
        "Type the word only — no ! needed (e.g. lincoln).",
        "Must start with the letter shown and be exactly the length shown.",
        "Must be in the UK (en-GB) dictionary and not already used this chain.",
      ],
      gifts: [
        "Money Gun → type fuse (or another game name) within 45s to switch.",
        "Session gifts still count toward throne / spend-war.",
      ],
      tips: [
        "Watch Starts with + Length before typing.",
        "Longer words and longer chains score more.",
        "If the fuse is critical, prioritise any valid word over a fancy one.",
      ],
    },
  },
  {
    id: "nfg_strike",
    slug: "nfg-strike",
    name: "NFG Strike",
    tag: "GRID PURGE · NEW",
    tagline: "Gift for a seat · gift-tier purge · last cell standing.",
    description:
      "Viewers claim a seat by gifting (Rose+). When the host locks the matrix (or the timer hits), gifts purge the grid: Rose lasers one cell, mid gifts shock a 3×3, huge gifts cascade ~30%. Last survivor wins Strike points — a separate board from Hunt/Crash. No free joins and no auto-purge.",
    image: "/games/nfg-strike.png",
    accent: "#2EE6A6",
    switchCommand: "strike",
    howToPlay: {
      overview:
        "Phase 1: gift to fill the 10×10 matrix. Phase 2 locks. Phase 3: gift purge until one cell remains — then a victory spotlight and auto-reset.",
      goal: "Survive the gift purge as the last cell, or spend gifts to clear the field.",
      chat: [
        "Free !join / likes are off — send a gift (Rose+) during fill to claim a seat.",
        "Money Gun → type strike within 45s to switch into this mode.",
      ],
      gifts: [
        "Fill: any gift ≥1◆ seats you on a random empty cell.",
        "Purge 1–9◆ (e.g. Rose): Orbital Laser — one random alive cell.",
        "Purge 10–99◆ (e.g. Doughnut): Plasma Shockwave — 3×3 cluster.",
        "Purge 100+◆ (e.g. Universe): Cascade Wipe — ~30% of remaining cells.",
        "Strike gifts and survivor wins use Strike points only (not Hunt).",
      ],
      tips: [
        "Host can Lock Grid early once 2+ gifted seats are filled.",
        "Nothing is eliminated without a gift (no auto strikes).",
        "Eliminated seats show as glitched red tiles.",
      ],
    },
  },
  {
    id: "nfg_hunt",
    slug: "nfg-hunt",
    name: "NFG Hunt",
    tag: "SCRAMBLE · UK ENGLISH",
    tagline: "Unscramble UK English words from chat — roses reveal letters, first solve wins.",
    description:
      "Classic scramble rounds with a UK English bank. Type the word in TikTok chat, climb the board, and duel friends mid-stream.",
    image: "/games/nfg-hunt.png",
    accent: "#A855F7",
    switchCommand: "hunt",
    howToPlay: {
      overview:
        "Letters of a secret UK English word are scrambled on screen. Chat races to type the unscrambled word. Timed hints and roses can reveal letters, but never the full solve.",
      goal: "Be first to type the correct word and take the round win.",
      chat: [
        "Type the full word in chat — no ! needed.",
        "Duel someone with duel @username (when duels are enabled).",
        "Progress: !checkin · !daily · !level",
      ],
      gifts: [
        "Rose — reveals letters (always leaves some hidden).",
        "Money Gun → type hunt to switch here (or another game name).",
      ],
      tips: [
        "Category / hint chips narrow the answer space.",
        "Hard rounds appear on a cadence in the deck — expect tougher UK words.",
      ],
    },
  },
  {
    id: "nfg_contexto",
    slug: "nfg-contexto",
    name: "NFG Contexto",
    tag: "MEANING · RANK RACE",
    tagline: "Guess by meaning — closer words climb the rank ladder toward #1.",
    description:
      "Every chat guess is scored by semantic closeness. Watch the live ladder update and race to rank #1 before the round ends.",
    image: "/games/nfg-contexto.png",
    accent: "#C084FC",
    switchCommand: "contexto",
    howToPlay: {
      overview:
        "There is one secret target word. Each guess gets a rank — lower is closer. The board shows the best nearby guesses for the whole room.",
      goal: "Land rank #1 (the exact word) before time runs out.",
      chat: [
        "Type any dictionary word as a guess — no ! needed.",
        "Green / better ranks mean you are semantically closer.",
      ],
      gifts: [
        "Rose — plants or steps a proximity hint (never reveals #1).",
        "Money Gun → type contexto to jump to this mode.",
      ],
      tips: [
        "Think synonyms and related topics, not just spelling.",
        "Use the live ladder — steal the direction of someone else’s warm guess.",
      ],
    },
  },
  {
    id: "nfg_wordwich",
    slug: "nfg-wordwich",
    name: "NFG Wordwich",
    tag: "ALPHABET · SANDWICH",
    tagline: "Alphabetical sandwich — land words before and after the secret prefix.",
    description:
      "Squeeze the secret with words that share a starting prefix. Green matches tighten the sandwich until someone locks the answer.",
    image: "/games/nfg-wordwich.png",
    accent: "#F0C75E",
    switchCommand: "wordwich",
    howToPlay: {
      overview:
        "A secret word sits between “before” and “after” lists. Chat types words that share the growing prefix. Valid hits tighten the sandwich until the secret is forced out.",
      goal: "Be the player who locks the exact secret word.",
      chat: [
        "Type candidate words in chat — no ! needed.",
        "Green shared starts mean you are on the right prefix track.",
      ],
      gifts: [
        "Money Gun → type wordwich to switch here.",
        "Session gifts still feed throne / spend-war.",
      ],
      tips: [
        "Watch the middle prefix — that is your compass.",
        "Alternate thinking “before” vs “after” alphabetically when stuck.",
      ],
    },
  },
  {
    id: "nfg_wordwheel",
    slug: "nfg-wordwheel",
    name: "NFG Wheel",
    tag: "CROSSWORD · CENTRE LETTER",
    tagline: "Spin the wheel — every guess must use the centre letter.",
    description:
      "Six-letter crossword wheels built from the UK bank. Spot patterns, use the centre letter, and clear the board from chat.",
    image: "/games/nfg-wordwheel.png",
    accent: "#DDD6FE",
    switchCommand: "wheel",
    howToPlay: {
      overview:
        "A wheel of letters surrounds a mandatory centre letter. Chat finds valid words that use the centre letter and fit the crossword slots.",
      goal: "Clear as many wheel words as possible; big finds score more.",
      chat: [
        "Type words in chat — they must use the centre letter.",
        "Only dictionary words that can be formed from the wheel count.",
      ],
      gifts: [
        "Rose — can reveal letters on unfinished words (never fully solves a word).",
        "Money Gun → type wheel to switch here.",
      ],
      tips: [
        "Start with short words using the centre letter to open the board.",
        "Longer words that fill crossword crossings pay better.",
      ],
    },
  },
  {
    id: "nfg_hangman",
    slug: "nfg-hangman",
    name: "NFG Hangman",
    tag: "ARENA · LIVE COMPANION",
    tagline: "Letter battles in the Hangman arena with all-time scoring and iOS companion play.",
    description:
      "Guess letters or the full word in chat or from the Hangman iOS app. Climb the Hangman all-time board and share app chat across NFG titles.",
    image: "/games/nfg-hangman.png",
    accent: "#E9B949",
    switchCommand: "hangman",
    howToPlay: {
      overview:
        "A blank word sits above the Hangman arena. Chat (or the iOS companion) guesses letters or the full word. Correct letters grow your circle; misses hurt.",
      goal: "Solve the word and finish with the biggest arena score.",
      chat: [
        "Type a single letter to guess that letter.",
        "Type the full word to attempt a solve.",
        "Companion app players share the same round and app chat.",
      ],
      gifts: [
        "Arena gifts can grow your circle / help (mode-specific FX).",
        "Money Gun → type hangman to switch here.",
      ],
      tips: [
        "Common vowels first, then high-frequency consonants.",
        "Hangman points stay on the Hangman all-time board (separate from Crash).",
      ],
    },
  },
  {
    id: "nfg_connect4",
    slug: "nfg-connect4",
    name: "NFG Connect 4",
    tag: "1V1 · QUEUE",
    tagline: "!join the queue — drop columns 1–7 in a gold vs purple duel.",
    description:
      "Classic Connect 4 for TikTok Live. Queue with !join, take turns dropping discs, and win four in a row.",
    image: "/games/nfg-connect4.png",
    accent: "#FFD36B",
    switchCommand: "connect 4",
    howToPlay: {
      overview:
        "Two players queue into a gold vs purple duel. On your turn, drop a disc into columns 1–7. First to four in a row wins.",
      goal: "Get four of your colour in a row — horizontal, vertical, or diagonal.",
      chat: [
        "!join — enter the matchmaking queue.",
        "When it is your turn, type a number 1–7 to drop in that column.",
      ],
      gifts: [
        "Money Gun → type connect 4 (or c4) to switch here.",
      ],
      tips: [
        "Block your opponent’s three-in-a-row threats first.",
        "Centre columns (3–4–5) usually give more winning lines.",
      ],
    },
  },
  {
    id: "nfg_push",
    slug: "nfg-push",
    name: "NFG Push",
    tag: "QUIZ WAR · GOLD VS PURPLE",
    tagline: "First correct answer shoves the seam — gold vs purple quiz war.",
    description:
      "Two sides battle for the middle. Chat answers quiz prompts; the first correct shove moves the seam and can wipe the other team.",
    image: "/games/nfg-push.png",
    accent: "#FBBF24",
    switchCommand: "push",
    howToPlay: {
      overview:
        "Gold vs Purple fight over a seam in the middle. A quiz prompt appears; the first correct chat answer shoves the seam toward the other side.",
      goal: "Push the seam all the way and wipe the opposing team.",
      chat: [
        "Type the answer to the on-screen quiz prompt — first correct shove wins the beat.",
        "Stay on your colour’s energy; gifts can amplify your side.",
      ],
      gifts: [
        "Gifts during Push can strengthen your side’s shove.",
        "Money Gun → type push to switch here.",
      ],
      tips: [
        "Read the full prompt — close spellings may not count.",
        "Host can skip a stuck question from the control deck.",
      ],
    },
  },
  {
    id: "nfg_stacks",
    slug: "nfg-stacks",
    name: "NFG Stacks",
    tag: "SORT · SPEED",
    tagline: "Sort four colours into tubes — type tube numbers, race the clock.",
    description:
      "Pour colours between tubes until each stack is pure. Fastest clears win; gifts can undo or reshuffle mid-run.",
    image: "/games/nfg-stacks.png",
    accent: "#A78BFA",
    switchCommand: "stacks",
    howToPlay: {
      overview:
        "Tubes hold mixed colours. Pour from one tube into another until each tube holds a single colour. Fastest clear wins the round.",
      goal: "Sort every tube to a pure colour in the shortest time.",
      chat: [
        "!join — claim a seat / run.",
        "Type two tube numbers to pour, e.g. 3 5 (from tube 3 into tube 5).",
        "You have a short window each move — plan ahead.",
      ],
      gifts: [
        "Hand Heart — undo last pour(s).",
        "Galaxy — skip / reshuffle turn effects (Stacks-specific).",
        "Money Gun → type stacks to switch here.",
      ],
      tips: [
        "Empty tubes are your buffer — don’t fill them carelessly.",
        "Undo with Hand Heart if you trap a colour.",
      ],
    },
  },
  {
    id: "nfg_tenable",
    slug: "nfg-tenable",
    name: "NFG Tenable",
    tag: "TOP 10 · LISTS",
    tagline: "Fill top-10 lists from chat — climb floors, spend Tenable points on boosts.",
    description:
      "Name items on themed top-10 boards. Correct hits score Tenable points you can spend on boosts — separate from Crash wallet points.",
    image: "/games/nfg-tenable.png",
    accent: "#E8C547",
    switchCommand: "tenable",
    howToPlay: {
      overview:
        "A themed top-10 list appears with empty floors. Chat names valid list entries to fill floors and earn Tenable points.",
      goal: "Fill as many floors as you can; spend Tenable points on boosts for bigger runs.",
      chat: [
        "Type answers that belong on the current top-10 list — no ! needed for guesses.",
        "Spend / boost commands use Tenable points (separate from Crash).",
      ],
      gifts: [
        "Gifts do not auto-fill floors — answers must come from chat.",
        "Money Gun → type tenable to switch here.",
      ],
      tips: [
        "Read the list theme carefully — near-misses won’t count.",
        "Tenable points stay on Tenable; they don’t transfer to Crash.",
      ],
    },
  },
];

export const FEATURED_GAME = GAMES.find((g) => g.featured) || GAMES[0];

/** Money Gun chat commands — keep in sync with overlay MODE_SWITCH aliases. */
export const MONEY_GUN_COMMANDS = GAMES.map((g) => ({
  name: g.name,
  command: g.switchCommand,
  slug: g.slug,
}));
